<div id="award">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Notability</h4>
                  <div class="card-body">
                    <p class="inner-lead">Our school is proud to have students who often participate in interschool competitions and events, showcasing their skills and talents to a wider audience. These competitions provide a unique opportunity for our students to learn from their peers, gain valuable experience, and build their confidence.
                    </p>  
                    <p class="inner-lead">At our school, we believe that participating in interschool competitions is an essential part of our students' personal and academic growth. Our students not only learn from their experiences but also form bonds with students from other schools, expanding their horizons and creating lasting friendships.
                    </p>
                    <p class="inner-lead">We take great pride in our students' achievements in these competitions, and we believe that their successes reflect our commitment to providing a comprehensive education that prepares them for success in all aspects of their lives. Our students' participation in these events also helps to raise our school's profile and enhances our reputation in the wider community.
                    </p>
                    <p class="inner-lead">We encourage our students to explore their interests and passions and to take advantage of the opportunities available to them through these competitions. We believe that by participating in these events, our students are developing the skills and experiences that will help them succeed in college, their careers, and life.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>